import { combineReducers, configureStore } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { commonReducer } from 'store/slices/common'

import {  userReducer } from './slices/user'
import {  transactionReducer } from './slices/transaction'
import { onboardingReducer } from './slices/onboarding'
import { notificationReducer } from './slices/notification'
// ... import other reducers (slice) here

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: [],
}

const persistedReducer = persistReducer(persistConfig, combineReducers({
  user: userReducer,
  common: commonReducer,
  transaction: transactionReducer,
  onboarding: onboardingReducer,
  notification: notificationReducer,
}));

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
})

export const persistor = persistStore(store)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch